import { Tab } from '@headlessui/react';
import * as React from 'react';
import { Campaign } from '@/interfaces';
import { ChannelTabList, ChannelTabsCustom } from '@/components/dashboard';
import { useRouter } from 'next/router';

interface SocialMediaTabsProps {
	campaignDetails?: Campaign;
}

export const SocialMediaTabs: React.FC<SocialMediaTabsProps> = ({
	campaignDetails,
}) => {
	const router = useRouter();
	const { tab } = router.query;
	const [selectedIndex, setSelectedIndex] = React.useState<number>(0);
	const [tabsList, setTabsList] = React.useState<ChannelTabList[]>([]);
	const [itemSelected, setItemSelected] = React.useState<string>('');

	//This is for when the user reloads
	React.useEffect(() => {
		if (tabsList.length > 0 && typeof tab === 'string') {
			const newIndex = tabsList.findIndex((t) =>
				t.channels.some((channel) => channel.name === tab)
			);

			setSelectedIndex(newIndex !== -1 ? newIndex : 0);
		}
	}, [tab, tabsList]);

	return (
		<div>
			<Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
				<Tab.Panels>
					<ChannelTabsCustom
						campaignDetails={campaignDetails}
						tabsList={tabsList}
						setTabsList={setTabsList}
						selectedIndex={selectedIndex}
						itemSelected={itemSelected}
						setItemSelected={setItemSelected}
					/>
				</Tab.Panels>
			</Tab.Group>
		</div>
	);
};
